import { getAdhocQuoteById, getEdgeQuoteById, getProjectById } from 'api'
import { EMC_FACES, EMC_MODELS, QUOTE_ADDITIONAL_ITEM_CATEGORIES, QUOTE_TYPES } from './enums'
import { getProfessionalInstallationPermitFee } from './quotePricing'

export const getQuotePriceBreakdown = (quote, installationOption = null) => {
  const additionalItems = quote?.additionalItems ? JSON.parse(quote.additionalItems) : []
  return {
    emcCost: (quote?.emcCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.EMC ? currentValue.price * 1 : 0),
      0
    ),
    monumentCost: (quote?.monumentCost || 0),
    shippingCost: (quote?.shippingCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.Shipping ? currentValue.price * 1 : 0),
      0
    ),
    taxCost: additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.Tax ? currentValue.price * 1 : 0),
      0
    ),
    overage: (quote?.overage || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.Overage ? currentValue.price * 1 : 0),
      0
    ),
    discount: (quote?.discount || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.Discount ? currentValue.price * 1 : 0),
      0
    ),
    fabricationCost: (quote?.cabinetCost || 0) + (quote?.pedestalCost || 0) + (quote?.emcBackWrapCost || 0) + (quote?.emcSideVentCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.Fabrication ? currentValue.price * 1 : 0),
      0
    ),
    customColorCost: (quote?.customColorCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.CustomColor ? currentValue.price * 1 : 0),
      0
    ),
    steelCost: (quote?.verticalSupportCost || 0) + (quote?.footerStyleCost || 0) + (quote?.plateCost || 0),
    installationCost: (quote?.installationCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.Installation ? currentValue.price * 1 : 0),
      0
    ),
    existingSignCost: (quote?.existingSignCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.ExistingSignRemoval ? currentValue.price * 1 : 0),
      0
    ),
    siteSurveyCost: (quote?.siteSurveyCost || 0) + additionalItems.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.category === QUOTE_ADDITIONAL_ITEM_CATEGORIES.SiteSurvey ? currentValue.price * 1 : 0),
      0
    ),
    permitCost: getProfessionalInstallationPermitFee(installationOption || quote?.installationOption),
    totalCost: (quote?.totalCost || 0)
  }
}

export const getQuoteByProjectId = async (projectId) => {
  try {
    const project = await getProjectById(projectId)
    let quote
    switch (project?.quoteType) {
      case QUOTE_TYPES.Edge:
        quote = await getEdgeQuoteById(project?.quoteId)
        break
      case QUOTE_TYPES.Adhoc:
        quote = await getAdhocQuoteById(project?.quoteId)
        break
      default:
        quote = null
        break
    }
    return quote
  } catch (err) {
    return null
  }
}

export const calculateQuoteEmcCost = (emcConfig, model, pitch, modsH, modsL, face) => {
  if (!emcConfig || !model || !pitch || !modsH || !modsL || !face) {
    return 0
  }

  // Find appropriate config based on model
  const ppms = model === EMC_MODELS.G5 ? emcConfig.ppms.g5 : emcConfig.ppms.g4
  const markup = model === EMC_MODELS.G5 ? emcConfig.markup.g5 : emcConfig.markup.g4

  // Find appropriate price per meter based on pitch
  const ppm = ppms.filter(v => v.pitch === pitch)?.[0]?.price || 0 // Price Per Meter

  // Find appropriate discount based on square feets
  let discount = 0
  const sqFeets = modsH * modsL
  const filteredDiscounts = emcConfig.discounts.filter(v => v.feet <= sqFeets)
  if (filteredDiscounts.length === 0) {
    discount = 0
  } else {
    const appropriateDiscount = filteredDiscounts.reduce((prev, curr) => (curr.feet > prev.feet ? curr : prev))
    discount = appropriateDiscount.percent
  }

  // Calculate square meters
  const sqMeters = modsH * modsL * 0.092903

  const cost = (sqMeters * ppm * (face === EMC_FACES.SF ? 1 : 2) + 1000) * (1 - discount / 100) * markup

  return cost
}
